/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { NettoyageDto } from '../models/nettoyage-dto';
import { NettoyageElementNettoyageDto } from '../models/nettoyage-element-nettoyage-dto';


/**
 * Fonctions de gestion des nettoyages
 */
@Injectable({
  providedIn: 'root',
})
export class NettoyagesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation nettoyageGetList
   */
  static readonly NettoyageGetListPath = '/api/nettoyages/list';

  /**
   * Renvoie la liste des nettoyages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyageGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<NettoyageDto>>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyageGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<NettoyageDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des nettoyages.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyageGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageGetList(params?: {
  }): Observable<Array<NettoyageDto>> {

    return this.nettoyageGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<NettoyageDto>>) => r.body as Array<NettoyageDto>)
    );
  }

  /**
   * Path part for operation nettoyageLoadList
   */
  static readonly NettoyageLoadListPath = '/api/nettoyages/load-list';

  /**
   * Renvoie la liste des nettoyages (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyageLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyageLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyageLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des nettoyages (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyageLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyageLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.nettoyageLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation nettoyageGet
   */
  static readonly NettoyageGetPath = '/api/nettoyages/{id}';

  /**
   * Renvoie le nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageGet$Response(params: {

    /**
     * Identifiant nettoyage
     */
    id: number;
  }): Observable<StrictHttpResponse<NettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyageGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NettoyageDto>;
      })
    );
  }

  /**
   * Renvoie le nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageGet(params: {

    /**
     * Identifiant nettoyage
     */
    id: number;
  }): Observable<NettoyageDto> {

    return this.nettoyageGet$Response(params).pipe(
      map((r: StrictHttpResponse<NettoyageDto>) => r.body as NettoyageDto)
    );
  }

  /**
   * Path part for operation nettoyagePut
   */
  static readonly NettoyagePutPath = '/api/nettoyages/{id}';

  /**
   * Met à jour le nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyagePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyagePut$Response(params: {

    /**
     * Identifiant du nettoyage
     */
    id: number;

    /**
     * Nettoyage
     */
    body: NettoyageDto
  }): Observable<StrictHttpResponse<NettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyagePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NettoyageDto>;
      })
    );
  }

  /**
   * Met à jour le nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyagePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyagePut(params: {

    /**
     * Identifiant du nettoyage
     */
    id: number;

    /**
     * Nettoyage
     */
    body: NettoyageDto
  }): Observable<NettoyageDto> {

    return this.nettoyagePut$Response(params).pipe(
      map((r: StrictHttpResponse<NettoyageDto>) => r.body as NettoyageDto)
    );
  }

  /**
   * Path part for operation nettoyageDelete
   */
  static readonly NettoyageDeletePath = '/api/nettoyages/{id}';

  /**
   * Supprime le nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyageDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageDelete$Response(params: {

    /**
     * Identifiant du nettoyage à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyageDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyageDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageDelete(params: {

    /**
     * Identifiant du nettoyage à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.nettoyageDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation nettoyagePost
   */
  static readonly NettoyagePostPath = '/api/nettoyages';

  /**
   * Crée le nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyagePost$Response(params: {

    /**
     * Nettoyage
     */
    body: NettoyageDto
  }): Observable<StrictHttpResponse<NettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyagePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NettoyageDto>;
      })
    );
  }

  /**
   * Crée le nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyagePost(params: {

    /**
     * Nettoyage
     */
    body: NettoyageDto
  }): Observable<NettoyageDto> {

    return this.nettoyagePost$Response(params).pipe(
      map((r: StrictHttpResponse<NettoyageDto>) => r.body as NettoyageDto)
    );
  }

  /**
   * Path part for operation nettoyageLoadListType
   */
  static readonly NettoyageLoadListTypePath = '/api/nettoyages/element/load-list/{nettoyageId}';

  /**
   * Renvoie la liste des éléments de nettoyage du nettoyage spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyageLoadListType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyageLoadListType$Response(params: {

    /**
     * Identifiant du nettoyage
     */
    nettoyageId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyageLoadListTypePath, 'post');
    if (params) {
      rb.path('nettoyageId', params.nettoyageId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des éléments de nettoyage du nettoyage spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyageLoadListType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyageLoadListType(params: {

    /**
     * Identifiant du nettoyage
     */
    nettoyageId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.nettoyageLoadListType$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation nettoyageGetType
   */
  static readonly NettoyageGetTypePath = '/api/nettoyages/element/{nettoyageId}/{id}';

  /**
   * Renvoie l'élément de nettoyage du nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyageGetType()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageGetType$Response(params: {

    /**
     * Identifiant du nettoyage
     */
    nettoyageId: number;

    /**
     * Identifiant de l&#x27;élément de nettoyage du nettoyage à mettre à jour
     */
    id: number;
  }): Observable<StrictHttpResponse<NettoyageElementNettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyageGetTypePath, 'get');
    if (params) {
      rb.path('nettoyageId', params.nettoyageId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NettoyageElementNettoyageDto>;
      })
    );
  }

  /**
   * Renvoie l'élément de nettoyage du nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyageGetType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nettoyageGetType(params: {

    /**
     * Identifiant du nettoyage
     */
    nettoyageId: number;

    /**
     * Identifiant de l&#x27;élément de nettoyage du nettoyage à mettre à jour
     */
    id: number;
  }): Observable<NettoyageElementNettoyageDto> {

    return this.nettoyageGetType$Response(params).pipe(
      map((r: StrictHttpResponse<NettoyageElementNettoyageDto>) => r.body as NettoyageElementNettoyageDto)
    );
  }

  /**
   * Path part for operation nettoyagePutType
   */
  static readonly NettoyagePutTypePath = '/api/nettoyages/element/{nettoyageId}/{id}';

  /**
   * Met à jour l'élément de nettoyage du nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nettoyagePutType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyagePutType$Response(params: {

    /**
     * Identifiant du nettoyage
     */
    nettoyageId: number;

    /**
     * Identifiant de l&#x27;élément de nettoyage du nettoyage à mettre à jour
     */
    id: number;

    /**
     * Elément de nettoyage du nettoyage
     */
    body: NettoyageElementNettoyageDto
  }): Observable<StrictHttpResponse<NettoyageElementNettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, NettoyagesService.NettoyagePutTypePath, 'put');
    if (params) {
      rb.path('nettoyageId', params.nettoyageId, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NettoyageElementNettoyageDto>;
      })
    );
  }

  /**
   * Met à jour l'élément de nettoyage du nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `nettoyagePutType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  nettoyagePutType(params: {

    /**
     * Identifiant du nettoyage
     */
    nettoyageId: number;

    /**
     * Identifiant de l&#x27;élément de nettoyage du nettoyage à mettre à jour
     */
    id: number;

    /**
     * Elément de nettoyage du nettoyage
     */
    body: NettoyageElementNettoyageDto
  }): Observable<NettoyageElementNettoyageDto> {

    return this.nettoyagePutType$Response(params).pipe(
      map((r: StrictHttpResponse<NettoyageElementNettoyageDto>) => r.body as NettoyageElementNettoyageDto)
    );
  }

}
